export function alphabeticalOrder(a, b) {
  if (a.node.display_country < b.node.display_country) {
    return -1
  }
  if (a.node.display_country > b.node.display_country) {
    return 1
  }
  return 0
}
